import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * Emergent auth callback: processes #session_id=... fragment, exchanges for cookie,
 * then navigates to /konto.
 */
export default function AuthCallback() {
    const navigate = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            navigate("/login", { replace: true });
            return;
        }
        const sessionId = decodeURIComponent(match[1]);

        (async () => {
            try {
                const { data } = await api.post("/auth/session", null, {
                    headers: { "X-Session-ID": sessionId },
                });
                setUser(data);
                // clean up hash and redirect
                window.history.replaceState({}, "", window.location.pathname);
                navigate("/konto", { replace: true, state: { user: data } });
            } catch (e) {
                navigate("/login", { replace: true, state: { error: "Google-Login fehlgeschlagen." } });
            }
        })();
    }, [navigate, setUser]);

    return (
        <div className="flex min-h-[70vh] items-center justify-center">
            <div className="text-center">
                <div className="mx-auto h-10 w-10 animate-spin rounded-full border-4 border-brand-500 border-t-transparent" />
                <p className="mt-4 text-sm text-ink-500">Anmeldung wird abgeschlossen …</p>
            </div>
        </div>
    );
}
